import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useState } from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import errorTriangle from '../../images/errorTriangle.png';
import Refesh from '../../images/Refresh.png';
import { VouchedFailed as classes } from './VouchedStyles';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { CLOSE, TRY_AGAIN, VOUCHED_ERROR, VOUCHED_ERROR_SUBTEXT } from '../../constants';
import { productNameURLMapping } from '../../services/productNameURLMapping';

function VouchedFailed({ attemptsLeft = 3 }) {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    location,
    language,
    productName,
    vouchedUploadCount,
    setVouchedUploadCount,
    theme,
    contactInformation,
    setCurrentPage,
    personalInformation,
  } = useContext(LeadGenerationContext);

  useEffect(() => {
    setCurrentPage('vouched-failed');
  }, []);

  const [open, setOpen] = useState(true);

  const isMaxAttemptsReached = vouchedUploadCount >= attemptsLeft;

  const handleButtonClick = () => {
    const newAttempts = vouchedUploadCount + 1;
    setVouchedUploadCount(newAttempts);
    setOpen(false);
    history.push(
      `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
        productName
      )}/vouched-success`
    );
  };

  return (
    <Box sx={{ ...classes.container, height: '100dvh', padding: 0 }}>
      <Grid item xs={2} sm={2} md={2} lg={2} sx={classes.imageBox}>
        <Box component="img" src={errorTriangle} alt={t('Error illustration')} sx={classes.image} />
      </Grid>
      <Grid item xs={12} md={6} sx={classes.textBox}>
        <Typography
          variant="h1"
          sx={{
            ...classes.heading,
            fontSize: '36px !important',
          }}
        >
          {t(VOUCHED_ERROR, { defaultValue: VOUCHED_ERROR })}
        </Typography>
        <Typography variant="subtitle1" color="errorSubtext" sx={classes.subtext}>
          {t(VOUCHED_ERROR_SUBTEXT, { defaultValue: VOUCHED_ERROR_SUBTEXT })}
        </Typography>
      </Grid>
      <Grid item xs={12} md={6} sx={classes.buttonGroup}>
        <Button
          component="button"
          onClick={handleButtonClick}
          disabled={isMaxAttemptsReached}
          sx={{
            ...classes.outlinedButton,
            border: `1px solid ${theme?.palette?.danger?.main}`,
            color: theme?.palette?.danger?.main,
            ...theme?.typography.subtitle1,
          }}
        >
          {t(CLOSE, { defaultValue: CLOSE })}
        </Button>
        <Button
          component="button"
          onClick={handleButtonClick}
          sx={classes.containedButton}
          disabled={isMaxAttemptsReached}
        >
          <Box component="img" src={Refesh} alt={t('Refresh')} sx={classes.refreshimage} />
          <Typography sx={classes.textBoxStyle} variant="subtitle1">
            {t(TRY_AGAIN, { defaultValue: TRY_AGAIN })}
          </Typography>
        </Button>
      </Grid>
    </Box>
  );
}

VouchedFailed.propTypes = {
  attemptsLeft: PropTypes.number,
};

export default VouchedFailed;
